import { CropContextState } from './crop-context-types';

export const initState: CropContextState = {
  cardCanvas: null,
  currentImage: null,
  isCropping: false,
  isSavingCroppedImage: false,
};
